import React from 'react'

import { Box, Tooltip, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function conditionNameColumn() {

	const iconMap = {
		"Cheapest": "coins",
		"Most expensive": "gem",
		"$": "money-bills",
		"Percentage": "percent",
		"Lower than": "arrow-down",
		"Higher than": "arrow-up",
	}

	const colorMap = {
		"Cheapest": "warning.main",
		"Most expensive": "colors.purple",
		"$": "success.dark",
		"Percentage": "black",
		"Lower than": "error.main",
		"Higher than": "success.main",
	}

	return {
		name: 'conditionName',
		label: 'Condition',
		options: {
			filter: false,
			customBodyRowRenderLite:
				(value, {
					comparatorName,
					comparatorPricesName,
					comparatorUnitName,
					positionPrice,
					comparatorValue
				}) => <Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column"
					}}>
					<Typography fontWeight="bold">{value}</Typography>
					<Box
						sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
						<Tooltip title="Position" placement="top" arrow>
							<Typography sx={{ fontWeight: "bold", mx: .3 }}>{positionPrice}º</Typography>
						</Tooltip>
						<IconSeeker
							tooltip={comparatorName}
							icon={iconMap[comparatorName]}
							sx={{
								fontSize: 14,
								color: colorMap[comparatorName],
								mx: .3
							}}
						/>
						<Tooltip title="Amount" placement="top" arrow>
							<Typography sx={{ fontWeight: "bold", mx: .3 }}>{comparatorValue}</Typography>
						</Tooltip>
						<IconSeeker
							tooltip="Currency"
							icon={iconMap[comparatorUnitName]}
							sx={{
								mx: .3,
								fontSize: 14,
								color: colorMap[comparatorUnitName]
							}}/>
						<IconSeeker
							tooltip={comparatorPricesName}
							icon={iconMap[comparatorPricesName]}
							sx={{
								mx: .3,
								fontSize: 14,
								color: colorMap[comparatorPricesName]
							}}
						/>
					</Box>
				</Box>
		}
	}
}